/* TYMWORK - animaciones base.
   CLAVE: Horizon no hace scroll en el documento (body con overflow:hidden),
   el scroll ocurre dentro de un contenedor interno. Por eso escuchamos el
   scroll en fase de CAPTURA sobre document, que sí recoge el scroll de
   cualquier contenedor de la página. */
(function () {
  'use strict';
  if (window.__twAnim1) return; window.__twAnim1 = 1;

  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.twOnScroll = function (fn) {
    document.addEventListener('scroll', fn, { passive: true, capture: true });
    window.addEventListener('resize', fn);
  };

  function splitLetters(el) {
    if (el.dataset.twSplit === 'done') return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    el.textContent = ''; var n = 0;
    text.split(' ').forEach(function (word, wi) {
      if (wi) el.appendChild(document.createTextNode(' '));
      var w = document.createElement('span'); w.className = 'tw-word';
      word.split('').forEach(function (ch) {
        var l = document.createElement('span'); l.className = 'tw-letter';
        l.style.setProperty('--i', n++);
        var inner = document.createElement('span'); inner.textContent = ch;
        l.appendChild(inner); w.appendChild(l);
      });
      el.appendChild(w);
    });
    el.dataset.twSplit = 'done';
  }

  function fitMark(el) {
    var word = el.querySelector('.tw-word'); if (!word) return;
    var cs = getComputedStyle(el);
    var avail = el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (avail <= 0) return;
    el.style.fontSize = '100px';
    var natural = word.offsetWidth; if (!natural) return;
    el.style.fontSize = Math.min(100 * avail / natural, window.innerHeight * 0.54) + 'px';
  }
  window.twFit = function () { $$('[data-tw-fit],[data-tw-fit2]').forEach(fitMark); };

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });

  function sweep() {
    $$('[data-tw-split]:not(.is-in),[data-tw-reveal]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.94 && r.bottom > 0) el.classList.add('is-in');
    });
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-tw-split="letters"]', scope).forEach(splitLetters);
    $$('[data-tw-split],[data-tw-reveal]', scope).forEach(function (el) { io.observe(el); });
    $$('[data-tw-stagger]', scope).forEach(function (g) {
      $$(':scope > *', g).forEach(function (c, i) { c.style.setProperty('--i', i); });
    });
    window.twFit();
    $$('.tw-hero [data-tw-split],.tw-hero [data-tw-reveal]', scope).forEach(function (el) {
      setTimeout(function () { el.classList.add('is-in'); }, 120);
    });
    var bg = document.querySelector('.tw-hero__bg');
    if (bg && !reduce && !bg.dataset.on) {
      bg.dataset.on = '1';
      var hero = bg.closest('.tw-hero');
      var tick = function () {
        var p = Math.min(1, Math.max(0, -hero.getBoundingClientRect().top / hero.offsetHeight));
        bg.style.transform = 'translateY(' + (p * 14) + '%) scale(' + (1 + p * 0.12) + ')';
      };
      tick(); window.twOnScroll(tick);
    }
    sweep();
  }

  function boot() {
    init(document);
    window.twOnScroll(sweep);
    window.addEventListener('load', function () { sweep(); window.twFit(); });
    window.addEventListener('resize', window.twFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(window.twFit);
    setTimeout(function () { sweep(); window.twFit(); }, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
